//#region Imports

import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AsyncResult } from '../../modules/http-async/models/async-result';
import { HttpAsyncService } from '../../modules/http-async/services/http-async.service';
import { QuizProgressPayload } from '../../models/payloads/progress/quiz-progress.payload';
import { UserProgressProxy } from '../../models/proxies/user-progress.proxy';
import { getPaginatedCrudData } from '../../utils/http';
import { createCrudUrl, CrudRequestParams } from '../../utils/crud';
import { UserProgressCourseProxy } from '../../models/proxies/user-progress-course.proxy';

//#endregion

type AsyncCreateUpdate = AsyncResult<QuizProgressPayload>;

@Injectable({
  providedIn: 'root',
})
export class UserProgressInteractor {

  //#region Constructors

  constructor(private readonly http: HttpAsyncService) {}

  //#endregion

  //#region Functions

  public async getMany(params: CrudRequestParams<UserProgressProxy>): Promise<AsyncResult<UserProgressProxy[]>> {
    const url = createCrudUrl(environment.api.userProgress.getMany, params);
  
    return await getPaginatedCrudData<UserProgressProxy>(this.http, url, 100);
  }

  public async isProgressReseted(
    courseId: string
  ): Promise<AsyncResult<{ reseted: boolean }>> {
    const url = environment.api.userProgress.isProgressReseted.replace(
      '{courseId}',
      courseId
    );

    return await this.http.get<{ reseted: boolean }>(url);
  }

  public async createQuizProgress(payload: QuizProgressPayload): Promise<AsyncCreateUpdate> {
    const url = environment.api.userProgress.quizCreate;

    return await this.http.post(url, payload);
  }

  public async updateQuizProgress(entitdyId: string, payload: QuizProgressPayload): Promise<AsyncCreateUpdate> {
    const url = environment.api.userProgress.quizUpdate.replace('{progressId}', entitdyId);

    return await this.http.put<QuizProgressPayload>(url, payload);
  }

  public async getUserProgress(courseId: string): Promise<AsyncResult<UserProgressCourseProxy>> {
    const url = createCrudUrl(environment.api.userProgress.getUserProgress, {
      search: {
        courseId: courseId
      } 
    });
  
    return await this.http.get<UserProgressCourseProxy>(url);
  }

  //#endregion

}
